var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6815 23.196L25.5 29.379V13.5C25.5 12.672 24.828 12 24 12C23.172 12 22.5 12.672 22.5 13.5V29.379L16.3185 23.1975C15.732 22.611 14.7825 22.611 14.1975 23.1975C13.611 23.784 13.611 24.7335 14.1975 25.3184L22.683 33.8039C23.043 34.1639 23.535 34.2749 24.0016 34.1924C24.4666 34.2749 24.9601 34.1624 25.3201 33.8039L33.8056 25.3184C34.3921 24.7319 34.3921 23.7825 33.8056 23.1975C33.2175 22.611 32.268 22.611 31.6815 23.196ZM24 0C10.746 0 0 10.7445 0 24C0 37.2555 10.746 48 24 48C37.254 48 48 37.254 48 24C48 10.746 37.2555 0 24 0ZM24 45C12.402 45 3 35.598 3 24C3 12.402 12.402 3 24 3C35.598 3 45 12.402 45 24C45 35.598 35.598 45 24 45Z",
    fill: "#00AEAE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.ecc976b66d081bf1280622267cba6ef6.svg";
export { ForwardRef as ReactComponent };